<div class="container mb-3">
  <div class="row">
    <div class="col-12">
      <h1 class="page-title">{{ "FORGOT_PASSWORD" | globalTranslate }}</h1>
    </div>
  </div>
  @if (!isForgotPasswordlinkPage) {
  <div class="ps-1 pb-1 hover-red">
    <div
      tabindex="0"
      class="btn btn-link hover-red back-link-button"
      (click)="onPrevious()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.875"
        height="15.75"
        viewBox="0 0 16.875 15.75"
      >
        <g
          id="_icons_arrow-back-outline"
          data-name="⚛️ icons/arrow-back-outline"
          transform="translate(0)"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
            transform="translate(0)"
            fill="#174a7c"
          />
        </g>
      </svg>
      <span class="ps-2">{{ "BACK_TO_PREVIOUS_PAGE" | globalTranslate }}</span>
    </div>
  </div>
  }
  <div class="card mb-4 no-border-card">
    <div class="card-body shadow-sm">
      @if (!isForgotPasswordlinkPage) {
      <div class="section-header">
        <h2>
          <strong>{{ "FORGOT_PASSWORD" | globalTranslate }}</strong>
        </h2>
        <hr />
      </div>
      } @if (isForgotPasswordlinkPage) {
      <div class="section-header">
        <h2>
          <strong>{{ "PASSWORD_RESET" | globalTranslate }}</strong>
        </h2>
        <hr />
      </div>
      } @if (!isForgotPasswordlinkPage) {
      <section>
        <form [formGroup]="forgotPassword">
          <div class="row g-3 field-row-spacer">
            <div class="col-md-10 col-lg-10 col-xs-12">
              <nh-field
                [isRow]="true"
                label="{{ 'USERNAME_EMAIL' | globalTranslate }}"
                class="label-section"
              >
                <input
                  id="fp_usernameOrEmail"
                  type="text"
                  name="usernameOrEmail"
                  formControlName="usernameOrEmail"
                  [attr.aria-label]="'USERNAME_EMAIL' | globalTranslate"
                  class="form-control"
                  minlength="6"
                  maxlength="63"
                  required
                />
              </nh-field>
            </div>
          </div>
          @if (isRecaptchaEnabled && loaderReady) {
          <re-captcha
            id="fp_recaptchaReactive"
            (resolved)="resolved($event)"
            formControlName="recaptchaReactive"
            [siteKey]="siteKey"
          >
          </re-captcha>
          }
          <br />
        </form>
      </section>
      } @if (isForgotPasswordlinkPage) {
      <section>
        <div class="row">
          <div class="col-md-12 col-xs-12">
            <p>{{ "RESET_INSTRUCTIONS" | globalTranslate }}</p>
          </div>
        </div>
        <div class="mb-2">
          <div class="pt-1 hover-red comments">
            <a
              class="btn btn-link hover-red back-link-button"
              [routerLink]="['/signin']"
            >
              <span class="pe-2">{{ "BACK_TO_LOGIN" | globalTranslate }}</span>
              <nh-exit-svg></nh-exit-svg>
            </a>
          </div>
        </div>
      </section>
      }
    </div>
  </div>
  @if (!isForgotPasswordlinkPage) {
  <div class="row mb-4">
    <div class="col-md-2">
      <button
        id="continue"
        class="btn d-grid btn-secondary"
        (click)="sendForgotPasswordLink()"
        [disabled]="forgotPassword.status != 'VALID'"
      >
        {{ "NEXT_BUTTON" | globalTranslate }}
      </button>
    </div>
  </div>
  }
</div>